export class InitializeActivityPropertySettingsState {
  static readonly type =
    '[ActivityPropertySettings] InitializeActivityPropertySettingsState';
}
